import * as React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import {
  GlassContainer,
  GlassCard,
} from '../glassmorphism/GlassmorphismStyles';
interface SignInSkeletonProps {
  isDark?: boolean;
}
export default function SignInSkeleton({ isDark }: SignInSkeletonProps) {
  return (
    <GlassContainer>
      <Box
        width={{ xs: '90%', sm: '450px' }}
        mx='auto'
        mt={{ xs: 12.5, md: 15 }}
        pb={4}
      >
        <GlassCard
          sx={{
            p: { xs: '24px 24px 32px 24px', sm: '32px 32px 48px 32px' },
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          {/* HEADER */}
          <Skeleton
            variant='text'
            sx={{
              mx: 'auto',
              width: 140,
              height: 36,
              transform: 'none',
              background: isDark ? 'rgba(0,92,173,0.65)' : 'rgba(0,36,58,0.75)',
            }}
          />

          {/* FORM */}
          <Stack spacing={{ xs: 1, sm: 2 }}>
            {/* EMAIL */}
            <Box>
              <Skeleton variant='text' width={80} height={24} />
              <Skeleton
                variant='rounded'
                height={40}
                sx={{ borderRadius: '32px' }}
              />
            </Box>

            {/* PASSWORD */}
            <Box>
              <Skeleton variant='text' width={100} height={24} />
              <Skeleton
                variant='rounded'
                height={40}
                sx={{ borderRadius: '32px' }}
              />
            </Box>

            {/* CHECKBOX */}
            <Skeleton variant='text' width={140} height={28} sx={{ mt: 1 }} />

            {/* BUTTON */}
            <Skeleton
              variant='rounded'
              height={48}
              sx={{
                borderRadius: '999px',
                mt: 1,
              }}
            />

            {/* FORGOT PASSWORD */}
            <Skeleton
              variant='text'
              width={180}
              height={24}
              sx={{ '&&': { m: '10px auto 0' } }}
            />
          </Stack>

          {/* FOOTER */}
          <Box>
            <Skeleton
              variant='text'
              width='80%'
              height={24}
              sx={{ mx: 'auto' }}
            />
          </Box>
        </GlassCard>
      </Box>
    </GlassContainer>
  );
}
